/*
  zip-gate.js – UX-lagret runt postnummerappen (AJ Zipcode Validator).

  Bygger lager 1, 2 och 4 ur postnummer-ux-analys-2026-09-23.md:
    1. Områdesraden överst uppdateras med sparat postnummer.
    2. Varje död (disabled) köpknapp får en levande knapp bredvid sig som
       öppnar postnummerrutan i stället för att inte göra någonting.
    4. Korgen och sidokorgen får samma besked ovanför kassaknappen.

  Invarianter (får inte brytas):
    - Appens `disabled` på [name="add"] rörs ALDRIG. Shopifys snabbkassaknappar
      speglar det attributet; tas det bort öppnas både köpknapp och Shop Pay.
    - Ersättningsknappen är type="button" med exakt en uppgift: öppna rutan.
      Den kan inte skicka formuläret.
    - Är tillståndet okänt räknas det som låst (fail-closed).
    - Allt körs om när listor ritas om vid filtrering och sidbyte.
*/
(function () {
  'use strict';

  var ZIP_KEY = 'pincode_val';
  var VALID_KEY = 'is_valid_zipcode';
  var MODAL_SELECTOR = '.ZipCodeRestrict.modal_popup';
  var CTA_LABEL = 'Ange postnummer för att boka';
  var CTA_LABEL_COMPACT = 'Ange postnummer';
  var CTA_LABEL_OUTSIDE = 'Utanför vårt område – byt postnummer';
  var CTA_LABEL_OUTSIDE_COMPACT = 'Utanför vårt område';
  var NOTICE_TEXT = 'Vi behöver ditt postnummer innan du bokar.';
  var CHECKOUT_SELECTORS = ['#checkout', '#CartDrawer-Checkout'];
  // Appens egen rad i sidhuvudet (två textrader inuti dess klickbara länk).
  var HEADER_LINE1 = '#text-line1';
  var HEADER_LINE2 = '#check_zipcode, .check_zipcode';
  var HEADER_FALLBACK = { line1: 'Se om vi kan leverera till dig', line2: 'Ange din postkod' };
  var HEADER_LINE2_OUTSIDE = 'Byt postnummer';
  var WALLET_SELECTORS = [
    '.cart__dynamic-checkout-buttons',
    '#dynamic-checkout-cart',
    '[data-shopify="dynamic-checkout-cart"]'
  ];

  function readKey(key) {
    try {
      return window.localStorage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  // Tre tillstånd, aldrig två:
  //   'none'    – inget postnummer angivet (appen skriver "null" eller "" hit)
  //   'outside' – postnummer angivet, men vi kör inte där (is_valid_zipcode = 0)
  //   'ok'      – postnummer angivet och vi kör där (is_valid_zipcode = 1)
  // Appen sparar alltid det inskrivna postnumret i pincode_val, även när svaret
  // blev nej – därför går 'outside' att skilja från 'none'. Okänt läge räknas
  // som 'none' (fail-closed: låst och be om postnummer).
  function zipState() {
    var raw = readKey(ZIP_KEY);
    raw = raw ? String(raw).trim() : '';
    if (!/^\d{3}\s?\d{2}$/.test(raw)) return { state: 'none', zip: '' };

    var valid = readKey(VALID_KEY);
    valid = valid === null ? '' : String(valid).trim();
    if (valid === '1') return { state: 'ok', zip: raw };
    if (valid === '0') return { state: 'outside', zip: raw };
    return { state: 'none', zip: raw };
  }

  function hasZip() {
    return zipState().state === 'ok';
  }

  function openModal(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    var modal = document.querySelector(MODAL_SELECTOR);
    if (modal) {
      modal.style.display = 'block';
      modal.classList.add('active');
      var field = modal.querySelector('input:not([type="hidden"])');
      if (field) {
        setTimeout(function () {
          try {
            field.focus();
          } catch (e) {
            /* fokus är en bonus, inte ett krav */
          }
        }, 60);
      }
      return;
    }
    // Appen har inte hunnit rendera rutan – falla tillbaka på dess egen trigger.
    var trigger = document.getElementById('zipcodeTriggerBtn') || document.getElementById('text-line1');
    if (trigger) trigger.click();
  }

  /* --- Lager 1: områdesraden ------------------------------------------- */

  function syncBar() {
    var bar = document.querySelector('[data-zip-gate-bar]');
    if (!bar) return;
    var text = bar.querySelector('[data-zip-gate-bar-text]');
    var button = bar.querySelector('[data-zip-gate-open]');
    if (!text || !button) return;

    if (!bar.dataset.promptText) {
      bar.dataset.promptText = text.textContent.trim();
      bar.dataset.promptLabel = button.textContent.trim();
    }

    var current = zipState();
    var newText = bar.dataset.promptText;
    var newLabel = bar.dataset.promptLabel;

    if (current.state === 'ok') {
      newText = 'Vi kör hos dig i ' + current.zip + '.';
      newLabel = 'Byt postnummer';
    } else if (current.state === 'outside') {
      newText = 'Vi kör tyvärr inte i ' + current.zip + ' ännu.';
      newLabel = 'Byt postnummer';
    }

    if (text.textContent !== newText) text.textContent = newText;
    if (button.textContent !== newLabel) button.textContent = newLabel;
    bar.classList.toggle('zip-gate-bar--ok', current.state === 'ok');
    bar.classList.toggle('zip-gate-bar--outside', current.state === 'outside');
  }

  /* --- Lager 1b: appens rad i sidhuvudet --------------------------------- */

  // Appen kan bara två lägen i sidhuvudet: "ange postnummer" och "vi kan
  // leverera". Skrivs ett postnummer utanför området sätter den tillbaka
  // prompten (zipjs.js rad 697 och 755) – raden ser alltså ut som om inget
  // postnummer vore angivet. Vi tar över texten i exakt det läget och lämnar
  // tillbaka appens egen text i de två lägen den klarar.
  function isOurHeaderText(value) {
    var t = (value || '').trim();
    return t.indexOf('Vi kör inte i ') === 0 || t === HEADER_LINE2_OUTSIDE;
  }

  var headerAppText = null;

  function syncHeaderTrigger() {
    var line1 = document.querySelector(HEADER_LINE1);
    if (!line1) return;
    var line2 = document.querySelector(HEADER_LINE2);
    var current = zipState();

    if (current.state !== 'outside') {
      if (isOurHeaderText(line1.textContent)) {
        var back = headerAppText || HEADER_FALLBACK;
        line1.textContent = back.line1;
        if (line2) line2.textContent = back.line2;
      } else {
        headerAppText = {
          line1: line1.textContent,
          line2: line2 ? line2.textContent : HEADER_FALLBACK.line2
        };
      }
      line1.classList.remove('zip-outside');
      if (line2) line2.classList.remove('zip-outside');
      return;
    }

    var text1 = 'Vi kör inte i ' + current.zip + ' ännu';
    if (line1.textContent.trim() !== text1) line1.textContent = text1;
    if (line2 && line2.textContent.trim() !== HEADER_LINE2_OUTSIDE) {
      line2.textContent = HEADER_LINE2_OUTSIDE;
    }
    line1.classList.add('zip-outside');
    line1.classList.remove('zip-deliverable');
    if (line2) line2.classList.add('zip-outside');
  }

  /* --- Lager 2: levande knapp i stället för död knapp -------------------- */

  // Appen märker sina spärrade knappar med title="Please enter zipcode".
  // Saknas märkningen räknas en disabled knapp ändå som postnummerspärrad,
  // utom när den uppenbart handlar om slutsåld vara.
  function isZipBlocked(button) {
    if (!button.disabled || hasZip()) return false;
    if (/zip/i.test(button.getAttribute('title') || '')) return true;
    return !/slutsåld|slut i lager|sold out|utsåld/i.test(button.textContent || '');
  }

  function isCompact(button) {
    return !!button.closest('.card, .card-wrapper, quick-add-modal, .quick-add');
  }

  // Gate-knappen ska läsa som en riktig temaknapp: den ärver köpknappens egna
  // klasser (form, höjd, padding, typsnitt) men inte den som tvingar grön färg.
  function themeButtonClasses(button) {
    var classes = (button.className || '').split(/\s+/).filter(function (name) {
      return name && name !== 'zip-gate-hidden' && name !== 'product-form__submit';
    });
    if (classes.indexOf('button') === -1) classes.unshift('button', 'button--full-width');
    classes.push('zip-gate-cta');
    return classes.join(' ');
  }

  function ctaFor(button) {
    var next = button.nextElementSibling;
    return next && next.classList.contains('zip-gate-cta') ? next : null;
  }

  function ctaLabel(button, state) {
    var compact = isCompact(button);
    if (state === 'outside') return compact ? CTA_LABEL_OUTSIDE_COMPACT : CTA_LABEL_OUTSIDE;
    return compact ? CTA_LABEL_COMPACT : CTA_LABEL;
  }

  function syncAddButton(button, state) {
    var cta = ctaFor(button);

    if (!isZipBlocked(button)) {
      if (cta) cta.remove();
      button.classList.remove('zip-gate-hidden');
      return;
    }

    if (!cta) {
      cta = document.createElement('button');
      cta.type = 'button';
      cta.className = themeButtonClasses(button);
      cta.setAttribute('data-zip-gate-open', '');
      button.insertAdjacentElement('afterend', cta);
    }

    var label = ctaLabel(button, state);
    if (cta.textContent !== label) cta.textContent = label;
    cta.classList.toggle('zip-gate-cta--outside', state === 'outside');
    button.classList.add('zip-gate-hidden');
  }

  function syncAddButtons() {
    var state = zipState().state;
    var buttons = document.querySelectorAll('[name="add"]');
    for (var i = 0; i < buttons.length; i++) syncAddButton(buttons[i], state);
  }

  /* --- Lager 4: korgen och sidokorgen ----------------------------------- */

  function buildNotice() {
    var notice = document.createElement('div');
    notice.className = 'zip-gate-notice';
    notice.setAttribute('data-zip-gate-notice', '');

    var text = document.createElement('p');
    text.className = 'zip-gate-notice__text';

    var cta = document.createElement('button');
    cta.type = 'button';
    cta.className = 'button button--full-width zip-gate-cta';
    cta.setAttribute('data-zip-gate-open', '');

    notice.appendChild(text);
    notice.appendChild(cta);
    return notice;
  }

  function fillNotice(notice, current) {
    var text = notice.querySelector('.zip-gate-notice__text');
    var cta = notice.querySelector('.zip-gate-cta');
    var newText = NOTICE_TEXT;
    var newLabel = CTA_LABEL;

    if (current.state === 'outside') {
      newText =
        'Vi kör tyvärr inte i ' +
        current.zip +
        ' ännu, så bokningen kan inte slutföras. Kontrollera postnumret eller kontakta oss.';
      newLabel = 'Byt postnummer';
    }

    if (text.textContent !== newText) text.textContent = newText;
    if (cta.textContent !== newLabel) cta.textContent = newLabel;
    notice.classList.toggle('zip-gate-notice--outside', current.state === 'outside');
    cta.classList.toggle('zip-gate-cta--outside', current.state === 'outside');
  }

  function syncCheckout() {
    var current = zipState();
    var locked = current.state !== 'ok';

    CHECKOUT_SELECTORS.forEach(function (selector) {
      var button = document.querySelector(selector);
      if (!button) return;
      var host = button.closest('.cart__ctas') || button.parentElement;
      if (!host) return;

      var notice = host.parentElement
        ? host.parentElement.querySelector('[data-zip-gate-notice]')
        : null;

      if (locked) {
        button.classList.add('zip-gate-hidden');
        if (!notice) {
          notice = buildNotice();
          host.insertAdjacentElement('beforebegin', notice);
        }
        fillNotice(notice, current);
      } else {
        button.classList.remove('zip-gate-hidden');
        if (notice) notice.remove();
      }
    });

    WALLET_SELECTORS.forEach(function (selector) {
      var wallets = document.querySelectorAll(selector);
      for (var i = 0; i < wallets.length; i++) {
        wallets[i].classList.toggle('zip-gate-hidden', locked);
      }
    });
  }

  /* --- Körning ---------------------------------------------------------- */

  var queued = false;

  function sync() {
    queued = false;
    syncBar();
    syncHeaderTrigger();
    syncAddButtons();
    syncCheckout();
  }

  function scheduleSync() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(sync);
  }

  function init() {
    sync();

    // Öppna rutan från alla våra egna knappar, även de som ritas senare.
    document.addEventListener('click', function (event) {
      var node = event.target;
      if (!node || !node.closest) return;
      if (node.closest('[data-zip-gate-open]')) openModal(event);
    });

    // Listor ritas om vid filtrering/paginering, korgen vid varje ändring,
    // och appen tar bort disabled när ett giltigt postnummer skrivits in.
    new MutationObserver(scheduleSync).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['disabled', 'title']
    });

    // Appen skriver postnumret till localStorage utan att alltid röra DOM.
    document.addEventListener('click', function (event) {
      var node = event.target;
      if (!node || !node.closest) return;
      if (node.closest(MODAL_SELECTOR)) {
        setTimeout(sync, 250);
        setTimeout(sync, 1200);
      }
    });
    window.addEventListener('storage', scheduleSync);
    window.addEventListener('pageshow', scheduleSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
